// Webpack Imports
import * as bootstrap from 'bootstrap';
import './swiper-init';
import './back-to-top';

import './animate.js';
import './menu-hover-desktop.js';
import './menu-toggle-mobile.js';

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(function (popoverTriggerEl) {
        new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus'
        });
    });
})();
